// Centralized URL helpers for clean, SEO-friendly URLs

// Category slug → query params mapping (for ProductsPage)
const CATEGORY_SLUG_MAP = {
    'gamer-pc':      { category: 'gaming_pc' },
    'irodai-pc':     { category: 'office_pc' },
    'munkaallomas':  { category: 'workstation' },
    'laptopok':      { category: 'laptop' },
    'alkatreszek':   { category: 'component' },
    'cpu':           { category: 'component', subcategory: 'cpu' },
    'gpu':           { category: 'component', subcategory: 'gpu' },
    'alaplap':       { category: 'component', subcategory: 'motherboard' },
    'memoria':       { category: 'component', subcategory: 'ram' },
    'tarhely':       { category: 'component', subcategory: 'storage' },
    'tapegyseg':     { category: 'component', subcategory: 'psu' },
    'haz':           { category: 'component', subcategory: 'case' },
    'hutes':         { category: 'component', subcategory: 'cooling' },
    'mobiltelefon':  { category: 'mobile_phone' },
    'tartozekok':    { category: 'accessory' },
    'monitorok':     { category: 'accessory', subcategory: 'monitor' },
    'billentyuzetek': { category: 'accessory', subcategory: 'keyboard' },
    'egerek':        { category: 'accessory', subcategory: 'mouse' },
    'kabelek':       { category: 'accessory', subcategory: 'cable' },
    'fejhallgatok':  { category: 'accessory', subcategory: 'headset' },
    'felujitott':    { condition: 'refurbished' },
};

// Reverse: query params → slug
const CATEGORY_REVERSE_MAP = {};
for (const [slug, params] of Object.entries(CATEGORY_SLUG_MAP)) {
    const key = [params.category, params.subcategory, params.condition].filter(Boolean).join('|');
    CATEGORY_REVERSE_MAP[key] = slug;
}

export function getCategorySlug(category, subcategory, condition) {
    if (condition === 'refurbished') return 'felujitott';
    const key = [category, subcategory].filter(Boolean).join('|');
    return CATEGORY_REVERSE_MAP[key] || null;
}

export function parseCategorySlug(slug) {
    return CATEGORY_SLUG_MAP[slug] || null;
}

export function categoryUrl(category, subcategory, condition) {
    const slug = getCategorySlug(category, subcategory, condition);
    if (slug) return `/products/${slug}`;
    // Fallback to query params
    const params = new URLSearchParams();
    if (category) params.set('category', category);
    if (subcategory) params.set('subcategory', subcategory);
    if (condition) params.set('condition', condition);
    return `/products?${params.toString()}`;
}

export function productUrl(product) {
    return `/termek/${product.slug || product.id}`;
}

export { CATEGORY_SLUG_MAP };
